import * as React from 'react'
import Container from '@/components/Container'
import ButtonSecondary from '@/components/ButtonSecondary'
import socialLinks from '@/lib/content/social-links'

import { motion } from 'framer-motion'
import { fadeIn } from '@/lib/utils/framer-motion-config'
import { useRouter } from 'next/router'

const ArticleSignOff: React.FunctionComponent = () => {
    const { asPath } = useRouter()

    return (
        <Container maxWidth="sm" paddingYPreset="article">
            <motion.div
                className="flex flex-col items-center space-y-8 pb-28 pt-4 sm:flex-row sm:justify-between sm:space-y-0 md:pb-36 lg:pb-48"
                {...fadeIn}
            >
                <ButtonSecondary button={true} url="/articles" classes="!max-w-[266px] px-8">
                    Back to all news
                </ButtonSecondary>
                <div className="flex items-center space-x-4">
                    <div title="Share this article" className="uppercase text-[#595959]">
                        Share this article
                    </div>
                    <div className="flex items-center space-x-5 text-purple">
                        {socialLinks.map((social, index) => {
                            if (social.shareUrl !== undefined) {
                                return (
                                    <ButtonSecondary
                                        key={index}
                                        title={`Go to our ${social.name}`}
                                        ariaLabel={`Go to our ${social.name}`}
                                        url={`${social.shareUrl}${process.env.NEXT_PUBLIC_SITE_URL}${asPath}`}
                                        classes="hover:text-opacity-40 text-purple transition duration-300 ease-in-out"
                                        target="_blank"
                                    >
                                        {social.icon}
                                    </ButtonSecondary>
                                )
                            }
                        })}
                    </div>
                </div>
            </motion.div>
        </Container>
    )
}

export default ArticleSignOff
